import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./App";
import reportWebVitals from "./utils/reportWebVitals";
import AuthWrapper from "./Components/AuthWrapper/AuthWrapper";

ReactDOM.render(
  <React.StrictMode>
    <AuthWrapper>
      <App />
    </AuthWrapper>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
